// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { useTheme } from '@mui/material';

import Tile, { TileProps } from '@components/Timeline/Tile/Tile';

// TYPES ---------------------------------------------------------------- //

export interface ConciergeDriveProps
  extends Omit<
    TileProps,
    'color' | 'extraWidthBeforeLabel' | 'extraWidthBetweenLabel' | 'extraWidthAfterLabel' | 'secondaryIcon' | 'variant'
  > {}

// COMPONENT ---------------------------------------------------------------- //

const ConciergeDrive = ({ ...props }: ConciergeDriveProps) => {
  const theme = useTheme();

  return (
    <Tile
      color={theme.palette.concierge.main}
      extraWidthBeforeLabel={'PICKUP'}
      extraWidthBetweenLabel={'DRIVE'}
      extraWidthAfterLabel={'DELIVERY'}
      secondaryIcon={null}
      variant={'solid'}
      {...props}
    />
  );
};

// EXPORT ---------------------------------------------------------------- //

export default ConciergeDrive;
